import { type StoryblokEditable } from '@activebrands/core-web/libs/storyblok/storyblok';

/**
 * Transform data that should be added to html-elements so that they are linked to the correct component in the Storyblok visual editor.
 * @param editable - Storyblok editable string. These attributes are used to identify the editable areas in the Storyblok preview.
 */
const transformPreviewEditable = (editable?: string): StoryblokEditable | undefined => {
    if (typeof editable !== 'string') {
        return undefined;
    }
    const content = editable.replace(/^<!--#storyblok#/, '').replace(/-->$/, '');
    const { uid } = JSON.parse(content);
    return {
        'data-blok-c': content,
        'data-blok-uid': uid,
    };
};

export default transformPreviewEditable;
